import { render } from "./ToastMessage.vue?vue&type=template&id=2507947c&ts=true"
import script from "./ToastMessage.vue?vue&type=script&lang=ts"
export * from "./ToastMessage.vue?vue&type=script&lang=ts"

import exportComponent from "/home/marvin/go/src/github.com/emvi/lernapp-prototype/app/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__